import { Line } from 'react-chartjs-2'
import { Box, Typography, Paper, Alert } from '@mui/material'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

interface QualityMetricsProps {
  plddtScores?: number[];
}

export const QualityMetrics = ({ plddtScores = [] }: QualityMetricsProps) => {
  if (!plddtScores) {
    return (
      <Alert severity="info" sx={{ mb: 2 }}>
        No quality metrics available
      </Alert>
    );
  }

  const scores = {
    residues: Array.from({length: plddtScores.length}, (_, i) => i + 1),
    plddt_scores: plddtScores
  };

  const plddtData = {
    labels: scores.residues,
    datasets: [{
      label: 'pLDDT Score',
      data: scores.plddt_scores,
      borderColor: 'rgb(75, 192, 192)',
      backgroundColor: 'rgba(75, 192, 192, 0.2)',
      tension: 0.1,
      fill: true
    }]
  }
  
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Model Quality Assessment'
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: 'pLDDT Score'
        }
      },
      x: {
        title: {
          display: true,
          text: 'Residue Position'
        }
      }
    }
  }

  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Model Quality Metrics
        </Typography>
      </Box>
      
      <Box sx={{ height: 400 }}>
        <Line data={plddtData} options={options} />
      </Box>
    </Paper>
  )
} 